const initialState = {}

export default function azubis(state = initialState) {
  return state
}
